import React, { useState, useEffect } from "react";
import _ from "lodash";
import Loader from "../../Pages/Loader/Loader.js";
import Toaster from "../../Pages/Toaster/Toaster.js";
import { NavLink, useNavigate } from "react-router-dom";
import TypeOne from "../img/type1.png";
import TypeTwo from "../img/BrchureMls.png";
import TypeThree from "../img/postCards.png";
import Printer from "../img/printer.png";
import Calender from "../img/calendar.png";


function Markting() {

    return (
        <div className="bg-secondary float-left w-100 pt-4 mb-4">
            <h3 className="mb-3 text-white">Marketing Materials</h3>
            <div className="row bg-light p-3 border-0 rounded-3">
                <div className="float-start w-100 mt-3 mb-5">
                    <div className="d-lg-flex d-md-flex d-sm-block d-block">
                        <div class="ms-lg-0 ms-md-5 ms-sm-5 ms-0 mt-lg-0 mt-md-0 mt-sm-4 mt-4 text-center">
                            <div className="form-check mb-0 p-0">
                                <img
                                    // className={templateType === "type1" ? "active" : ""}
                                    src={Printer}
                                    alt="Type One"
                                    style={{ cursor: "pointer" }}
                                    width="80px"
                                   
                                />
                            </div>
                            <NavLink
                                to={`/print-markting`}
                                className="btn btn-primary mt-2"
                            >
                                Print Marketing
                            </NavLink>
                        </div>

                        <div class="ms-lg-5 ms-md-5 ms-sm-5 ms-0 mt-lg-0 mt-md-0 mt-sm-4 mt-4 text-center">
                            <div className="form-check mb-0 p-0">
                                <img
                                    // className={templateType === "type1" ? "active" : ""}
                                    src={Calender}
                                    alt="Type One"
                                    style={{ cursor: "pointer" }}
                                    width="80px"
                                    
                                />
                            </div>
                            <NavLink
                                to={`/market-calendar`}
                                className="btn btn-primary mt-2"
                            >
                                Market Calender
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>

   );

}
export default Markting;